export default "__VITE_PUBLIC_ASSET__662f2e7b__"